<template lang="pug">
transition(name="fade")
  .fixed.inset-x-0.top-0.z-50.text-white.font-bold(v-if="show")
    .rounded-lg.shadow-md.p-6.pr-10(
      :class="[errorClass, successClass]"
      style="min-width: 240px"
    )
      .flex.items-center
        slot
        span.absolute.top-0.bottom-0.right-0.px-4.py-3(@click="$emit('update:show', false)")
          <svg class="fill-current h-6 w-6 text-white" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
</template>

<script>
export default {
  name: 'SwFlash',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    errorClass () {
      return this.error ? 'bg-red-500' : '';
    },
    successClass () {
      return this.error ? 'bg-green-500' : '';
    },
  },
  watch: {
    show (newValue) {
      if (newValue) {
        setTimeout(() => this.$emit('update:show', false), 5000);
      }
    },
  },
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
